/** #963 — apply playUri success markers after IPC timeout + verify PLAYING. */

import { useMaestroStore } from '../store/maestroStore';
import { clearExclusiveErrorOnPlaybackConfirmed } from '../utils/exclusiveFallbackUI';
import { clearPlayUriPending } from './playUriConfirmation';
import { isLocalNativeRendererId } from './localNativeRenderer';

export type PlayUriTimeoutSuccessHost = {
  _shouldUseExclusive(): Promise<boolean>;
  _startExclusivePoller(): void;
  readonly _exclusiveActive: boolean;
  _lastPlayUriSuccessAt: number;
  _playUriFails: number;
};

export async function applyPlayUriTimeoutVerifySuccess(
  host: PlayUriTimeoutSuccessHost,
  rendererId: string | null | undefined,
): Promise<void> {
  host._lastPlayUriSuccessAt = Date.now();
  host._playUriFails = 0;
  const store = useMaestroStore.getState();
  store.setRendererHasStream(true);
  if (store.playbackState === 'loading') store.setPlaybackState('playing');
  clearExclusiveErrorOnPlaybackConfirmed();
  clearPlayUriPending('timeout_verify_playing');
  const exclusiveUsb = !rendererId && (await host._shouldUseExclusive());
  const localNative = !!rendererId && isLocalNativeRendererId(rendererId);
  if ((exclusiveUsb || localNative) && !host._exclusiveActive) host._startExclusivePoller();
}
